import { render, staticRenderFns } from "./articleLib.vue?vue&type=template&id=f35d2f94&scoped=true&"
import script from "./articleLib.vue?vue&type=script&lang=js&"
export * from "./articleLib.vue?vue&type=script&lang=js&"
import style0 from "./articleLib.vue?vue&type=style&index=0&id=f35d2f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35d2f94",
  null
  
)

export default component.exports